var _style, _rect, _text, _text2, _text3, _text4, _text5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 755.1 265",
    style: {
      enableBackground: "new 0 0 755.1 265"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{font-family:'Georgia';}\r\n\t.st2{font-size:72px;}\r\n\t.st3{fill:#415AA8;}\r\n\t.st4{font-size:180px;}\r\n\t.st5{fill:#ED1C24;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8.5,
    className: "st0",
    width: 824.7,
    height: 384
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1.620483e-02 144.5488)",
    className: "st1 st2"
  }, "La ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 97.1162 144.5488)",
    className: "st3 st1 st4"
  }, "timeline")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 755.1161 144.5488)",
    className: "st1 st2"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1.620483e-02 230.9488)",
    className: "st1 st2"
  }, "des ")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 124.6162 230.9488)",
    className: "st5 st1 st2"
  }, "Pr\xE9sidents Fran\xE7ais")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6e40b78cb1255e6d0505212aff245b6b.svg";
export { ForwardRef as ReactComponent };